import {useMemo} from "react"
import {createLogger} from "../logger"

/**
 * Hook to create a component-specific logger
 *
 * @param componentName The name of the component for namespacing logs
 * @returns A logger instance scoped to the component
 *
 * @example
 * // Inside a component
 * const logger = useLogger('UserProfile');
 * logger.info('User profile loaded', { userId: '123' });
 */
export const useLogger = (componentName: string) => {
  return useMemo(() => {
    return createLogger(componentName)
  }, [componentName])
}
